import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import getSiteWeatherActualsCoverage, {
  WeatherActualsCoverageResponse,
} from "../http/getSiteWeatherActualsCoverage";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface UseWeatherActualsParams {
  siteId: string;
  enabled?: boolean;
}

const useWeatherActuals = ({ siteId, enabled }: UseWeatherActualsParams) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const coverageQuery: UseQueryResult<WeatherActualsCoverageResponse, unknown> =
    useQuery(
      ["site", siteId, "weather_actuals_coverage"],
      async () => {
        return getSiteWeatherActualsCoverage(
          await getAuthTokenBlocking(getToken, relogin),
          siteId
        );
      },
      {
        enabled: enabled ?? true,
        staleTime: 5 * 60 * 1000,
        retry: false,
      }
    );

  return { coverageQuery };
};

export default useWeatherActuals;
